import useMeasure from "react-use-measure";
import { ResizeObserver } from "@juggle/resize-observer";
import { useEffect, useRef } from "react";

function useMeasureForCssVar(config) {
  const [ref, rect] = useMeasure({ debounce: config?.debounce ?? 100, polyfill: ResizeObserver });
  const configRef = useRef(config);

  useEffect(() => {
    configRef.current = config;
  }, [config]);

  useEffect(() => {
    try {
      if (configRef.current?.use) {
        let elementScope = configRef.current?.elementScope ?? document.documentElement;

        if (typeof elementScope === "string") {
          elementScope = document.querySelector(elementScope);
        }

        if (elementScope) {
          for (const [rectField, varName] of configRef.current?.use) {
            elementScope.style.setProperty(varName, `${rect[rectField]}px`);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [rect]);

  return [ref, rect];
}

export default useMeasureForCssVar;
